// extracted by mini-css-extract-plugin
module.exports = {"gw_reviewInfo_para":"SummaryPage_gw_reviewInfo_para__S0zrB","gwReviewInfoPara":"SummaryPage_gw_reviewInfo_para__S0zrB"};